import { create } from 'zustand';

const LS_KEY = 'proclaim-dark';

function readDarkMode(): boolean {
  const stored = localStorage.getItem(LS_KEY);
  if (stored !== null) return stored === 'true';
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

interface UIState {
  darkMode: boolean;
  sidebarOpen: boolean;
  // Whether the current user can perform admin-only actions (deletes). Defaults
  // to true for local / desktop / no-Clerk modes; AuthBridge lowers it to the
  // real Clerk membership role on the web so editors don't see delete buttons
  // the server will reject with 403.
  isAdmin: boolean;
  toggleDarkMode: () => void;
  toggleSidebar: () => void;
  setIsAdmin: (v: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  darkMode: readDarkMode(),
  sidebarOpen: false,
  isAdmin: true,

  toggleDarkMode: () => {
    set((s) => {
      const newMode = !s.darkMode;
      localStorage.setItem(LS_KEY, String(newMode));
      document.documentElement.classList.toggle('dark', newMode);
      return { darkMode: newMode };
    });
  },

  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),

  setIsAdmin: (v) => set({ isAdmin: v }),
}));
